export default {
    caffeine: {
        name: "Caffeine Free",
        src: "https://scdn.onnit.com/images/badges/old-style/caffeine-free.png",
        style: { maxWidth: 60 },
    },
    dairy: {
        name: "Dairy Free",
        src: "https://scdn.onnit.com/images/badges/badge_dairy_free.png",
        style: { maxWidth: 60 },
    },
    gluten: {
        name: "Gluten Free",
        src: "https://scdn.onnit.com/images/badges/badge_gluten_free.png",
        style: { maxWidth: 60 },
    },
    informedSport: {
        name: "Informed Sport",
        src: "https://scdn.onnit.com/images/badges/badge_informed_sport.png",
        style: { maxWidth: 60 },
    },
    soy: {
        name: "Soy Free",
        src: "https://scdn.onnit.com/images/badges/badge_soy_free.png",
        style: { maxWidth: 60 },
    },
    vegan: {
        name: "Vegan",
        src: "https://scdn.onnit.com/images/badges/badge_vegan.png",
        style: { maxWidth: 60 },
    },
};
